import React from 'react';

// reactstrap
import { CardTitle, CardSubtitle } from 'reactstrap'

export default function TituloLogin() {
    return (
        <>
            <CardTitle tag={'h4'} className='mb-4 font-weight-normal'>Bem vindo ao Coletas RGG!</CardTitle>
            <CardSubtitle tag="p" style={{ color: "#bbb", fontSize: '10pt' }} className='mb-4'>
                Sistema de gestão de residuos de grandes geradores
            </CardSubtitle>
            <div className="mb-3">
                <img src={require('assets/img/LogoSistema.png')} className='img-logo' alt="logo do sistema coletas RGG" />
            </div>
        </>
    )
}